import {
  BarChart3,
  BookOpen,
  CalendarDays,
  Code2,
  Database,
  FileText,
  LayoutDashboard,
  MessagesSquare,
  Network,
  PanelsTopLeft,
  TrendingUp,
  Users,
  UsersRound,
} from 'lucide-react'
import {
  buildV3AdminCustomCalendarPath,
  buildV3AdminFlightControlPath,
  buildV3AdminPlanCentralPath,
  buildV3ClientDashboardPath,
  buildV3ClientDashboardPerformancePath,
  buildV3ClientDashboardReportsPath,
  buildV3ClientMeetingsPath,
  buildV3ClientUploadDataPath,
  buildV3CrossClientDashboardPath,
  buildV3DevToolsPath,
  buildV3UsersPath,
} from './ClientDashboardV3'

export function isTrafficConversionEnabled() {
  return process.env.REACT_APP_II_80_TRAFFIC_CONVERSION === 'true'
}

export function buildV3PortalGroups(
  clientCode = '',
  clientId = '',
  includeTrafficConversion = isTrafficConversionEnabled(),
  badges: { connections?: string | number; messages?: string | number } = {},
) {
  const clientBase = clientCode ? `/v3/client/${encodeURIComponent(clientCode)}/portal` : '/v3/portal'
  const retailDashboard = clientCode ? buildV3ClientDashboardPath(clientCode) : buildV3CrossClientDashboardPath()
  const retailItems = [
    { key: 'retail-dashboard', label: 'Dashboard', to: retailDashboard, product: 'retail' as const, icon: LayoutDashboard, exact: true },
    { key: 'performance', label: 'Performance', to: clientCode ? buildV3ClientDashboardPerformancePath(clientCode) : '/v3/portal/retail-performance', product: 'retail' as const, icon: BarChart3, matchPrefixes: clientCode ? [buildV3ClientDashboardPerformancePath(clientCode)] : undefined, exact: !clientCode },
    { key: 'reports', label: 'Reports', to: clientCode && clientId ? buildV3ClientDashboardReportsPath(clientCode, clientId) : `${clientBase}/retail-reports`, product: 'retail' as const, icon: FileText, matchPrefixes: clientCode && clientId ? [buildV3ClientDashboardReportsPath(clientCode, clientId)] : undefined, exact: !(clientCode && clientId) },
    { key: 'meetings', label: 'Meetings', to: clientCode ? buildV3ClientMeetingsPath(clientCode) : '/v3/portal/retail-meetings', product: 'retail' as const, icon: Users, matchPrefixes: clientCode ? [buildV3ClientMeetingsPath(clientCode)] : undefined, exact: !clientCode },
    { key: 'data', label: 'Data', to: clientCode ? buildV3ClientUploadDataPath(clientCode) : '/v3/portal/retail-data', product: 'retail' as const, icon: Database, matchPrefixes: clientCode ? [buildV3ClientUploadDataPath(clientCode)] : undefined, exact: !clientCode },
  ]
  const indieItems = [
    { key: 'indie-dashboard', label: 'My Insights', to: `${clientBase}/indie-dashboard`, product: 'indie' as const, icon: LayoutDashboard },
    { key: 'content', label: 'Content & Discussions', to: `${clientBase}/content`, product: 'indie' as const, icon: BookOpen },
    { key: 'benchmarking', label: 'Benchmarking', to: `${clientBase}/benchmarking`, product: 'indie' as const, icon: BarChart3 },
    { key: 'trending', label: "What's Trending", to: `${clientBase}/trending`, product: 'indie' as const, icon: TrendingUp },
    ...(includeTrafficConversion ? [{ key: 'traffic-conversion', label: 'Traffic & Conversion', to: `${clientBase}/traffic-conversion`, product: 'indie' as const, icon: TrendingUp }] : []),
    { key: 'directory', label: 'Member Directory', to: `${clientBase}/directory`, product: 'indie' as const, icon: UsersRound, dividerBefore: true },
    { key: 'connections', label: 'My Connections', to: `${clientBase}/connections`, product: 'indie' as const, icon: Network, badge: badges.connections },
    { key: 'messages', label: 'Messages', to: `${clientBase}/messages`, product: 'indie' as const, icon: MessagesSquare, badge: badges.messages },
  ]

  return [
    { key: 'retail', label: 'RetailORBIT', mark: 'RO', items: retailItems },
    { key: 'indie', label: 'Indie Insights', mark: 'ii', items: indieItems },
  ]
}

export function buildV3AdminMenuItems({ visible = false, includeDevTools = false } = {}) {
  if (!visible && !includeDevTools) return []

  return [
    { key: 'flight-control', label: 'Flight Control', to: buildV3AdminFlightControlPath(), icon: PanelsTopLeft },
    { key: 'custom-calendars', label: 'Custom Calendars', to: buildV3AdminCustomCalendarPath(), icon: CalendarDays },
    { key: 'user-management', label: 'User Management', to: buildV3UsersPath(), icon: Users },
    { key: 'plans', label: 'Plans', to: buildV3AdminPlanCentralPath(), icon: FileText },
    ...(includeDevTools ? [{ key: 'dev-tools', label: 'Dev Tools', to: buildV3DevToolsPath(), icon: Code2 }] : []),
  ]
}
